<i class="fa fa-spin" [ngClass]="'fa-' + icon"></i>